import { formatPrice } from "@/utils";
import i18n from "@/i18n";

export default {
	responsive: true,
	maintainAspectRatio: false,
	title: {
		display: false,
	},
	tooltips: {
		mode: "index",
		intersect: false,
		custom: function(tooltip: any) {
			if (!tooltip) {
				return;
			}
			tooltip.displayColors = false;
		},
		callbacks: {
			// use label callback to return the desired label
			label: function(tooltipItem: any, data: any) {
				if (tooltipItem.datasetIndex === 0) {
					return i18n.t("assets") + formatPrice(tooltipItem.yLabel) + " EUR";
				} else {
					return "P/L:    " + formatPrice(tooltipItem.yLabel) + " %";
				}
			},
			title: function(tooltipItem:any, data:any) {
				return tooltipItem[0].xLabel;
			},
		},
	},
	legend: {
		display: true,
		labels: {
			usePointStyle: true,
		}
	},
	hover: {
		mode: "index",
		intersect: false,
		animationDuration: 0
	},
	scales: {
		xAxes: [
			{
				display: true,
				scaleLabel: {
					display: true,
				},
				gridLines: {
					drawOnChartArea: false,
					color: "#3c3c3c",
					drawTicks: true,
					lineWidth: 1,
				},
				ticks: {
					maxTicksLimit: 30,
					display: true,
				},
			},
		],
		yAxes: [
			{
				id: 'left-y-axis',
				position: 'left',
				display: true,
				scaleLabel: {
					display: true,
				},
				gridLines: {
					drawOnChartArea: true,
					color: "#3c3c3c",
					drawTicks: true,
					lineWidth: 1,
				},
				ticks: {
					maxTicksLimit: 5,
					display: true,
					callback: function(value: number) {
						return formatPrice(value, 2) + " EUR";
					},
				},
			},
			{
				id: 'right-y-axis',
				position: 'right',
				display: true,
				scaleLabel: {
					display: true,
				},
				ticks: {
					maxTicksLimit: 5,
					display: true,
					callback: function(value: number) {
						return formatPrice(value, 2) + " %";
					},
				},
			},
		],
	},
	layout: {
		padding: {
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
		},
	},
};
